<template>
  <b-badge :variant="log_status.badgeClass">
    <i :class="'fa' + ' ' + log_status.icon"></i>
    {{ log_status.name }}
  </b-badge>
</template>
<script>
export default {
  props: ["log_status"],
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Importacao/CardLogStatus.vue